/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon5IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon5Icon(props: Icon5IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 28 28"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <mask
        id={"a"}
        width={"28"}
        height={"28"}
        x={"0"}
        y={"0"}
        maskUnits={"userSpaceOnUse"}
        style={{
          maskType: 'alpha"'
        }}
      >
        <path fill={"#D9D9D9"} d={"M0 0h28v28H0z"}></path>
      </mask>

      <g mask={"url(#a)"}>
        <path
          fill={"#6D28D9"}
          d={
            "M7.874 17.19v-1.167H4.957v-1.75h5.833v-2.916h-4.8a1 1 0 0 1-.736-.297 1 1 0 0 1-.297-.735V5.972q0-.439.297-.735a1 1 0 0 1 .735-.297h1.885V3.773h1.75V4.94h2.916v1.75H6.707v2.917h4.801a1 1 0 0 1 .736.296 1 1 0 0 1 .296.736v4.352a1 1 0 0 1-.296.736 1 1 0 0 1-.736.296H9.624v1.167zm8.4 6.888-4.555-4.555 1.23-1.23 3.325 3.326 6.614-6.614 1.23 1.23z"
          }
        ></path>
      </g>
    </svg>
  );
}

export default Icon5Icon;
/* prettier-ignore-end */
